import 'models/CacheableDataObject';
import { Character } from './Character';
import { League } from './League';
import { CacheableDataObject } from './CacheableDataObject';
import { GameRoom } from './GameRoom';
import PlayOption from './PlayOption';

export default class PlayOptions extends CacheableDataObject {

	beforeConstruct() {
		this.ladder = null;
	}

	makePlayOption(gameCount, isRanked, teamSize, player, bigSetMatchmaking) {
		const data = {
			gameCount,
			isRanked,
			teamSize,
			ladderId: this.ladder.id,
			bigSetMatchmaking
		};
		if(player) {
			data.playerId = player.isMe() ? null : player.id;
			data.player = player.isMe() ? null : player;
		}
		return PlayOption.create(data);
	}

	afterUpdate() {
		if(this.ladder_id) {
			if(!(this.ladder instanceof GameRoom)) {
				if(this.ladder) {
					this.ladder = GameRoom.retrieve(this.ladder);
				}
				else {
					this.ladder = GameRoom.retrieveById(this.ladder_id);
				}
			}
		}
	}

	createPlayOptions(player, showBigSetCounts) {
		const playOptions = this;
		const friendlyOptionsSingles = [];
		const friendlyOptionsDoubles = [];
		const rankedOptionsSingles = [];
		const rankedOptionsDoubles = [];
		friendlyOptionsSingles.push(this.makePlayOption(0, false, 1, player));
		if(playOptions.has_bo3) {
			if(showBigSetCounts) {
				friendlyOptionsSingles.push(this.makePlayOption(3, false, 1, player, true));
				friendlyOptionsSingles.push(this.makePlayOption(5, false, 1, player, true));
			}
			if(playOptions.can_play_ranked && playOptions.has_ranked) {
				rankedOptionsSingles.push(this.makePlayOption(3, true, 1, player));
				rankedOptionsSingles.push(this.makePlayOption(5, true, 1, player));
				if(showBigSetCounts) {
					rankedOptionsSingles.push(this.makePlayOption(7, true, 1, player, true));
					rankedOptionsSingles.push(this.makePlayOption(9, true, 1, player, true));
					rankedOptionsSingles.push(this.makePlayOption(11, true, 1, player, true));
					rankedOptionsSingles.push(this.makePlayOption(13, true, 1, player, true));
				}
			}
		}
		if(playOptions.has_doubles && playOptions.max_friendly_team_size === 2) {
			friendlyOptionsDoubles.push(this.makePlayOption(0, false, 2, player));
			if(playOptions.has_bo3) {
				if(showBigSetCounts) {
					friendlyOptionsDoubles.push(this.makePlayOption(3, false, 2, player, true));
					friendlyOptionsDoubles.push(this.makePlayOption(5, false, 2, player, true));
				}
				if(playOptions.has_ranked_doubles) {
					if(playOptions.can_play_ranked && playOptions.has_ranked) {
						rankedOptionsDoubles.push(this.makePlayOption(3, true, 2, player));
						rankedOptionsDoubles.push(this.makePlayOption(5, true, 2, player));

					}
				}
			}
		}
		return {
			friendlyOptionsSingles,
			friendlyOptionsDoubles,
			rankedOptionsSingles,
			rankedOptionsDoubles
		};
	}

	toString() {
		return this.ladder_id;
	}
}
PlayOptions.prototype.dataLocationParsers = {
	slots: (options, data) => {
		options.slots = [];
		data.slots.forEach((slot) => {
			const convertedSlot = { ...slot };
			convertedSlot.characters = [];
			_.each(slot.characters, (character) => {
				convertedSlot.characters.push(Character.retrieve(character));
			});
			if(slot.league) {
				convertedSlot.league = League.retrieve(slot.league);
			}
			options.slots.push(convertedSlot);
		});
	},
};